import React from 'react';
import GUID from 'bz-utilities/modules/variables/guid';
import InvoiceType from 'bz-pronto-core/enum/invoice-type';
import ProntoInvoiceStatus from 'bz-pronto-core/enum/pronto-invoice-status';

class DiscountMenuItem extends React.Component {
  render() {
    return !!this.show ? this.props.children : null;
  }

  get show() {
    let { invoice = {} } = this.props;
    let { globalId, globalType, metadata = {} } = invoice;

    if (globalType !== InvoiceType.Pronto) return true;
    if (!globalId || GUID.isEmpty(globalId)) return false;

    return metadata.status === ProntoInvoiceStatus.Accepted;
  }
}

export default DiscountMenuItem;
